import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';

export const AuthActions = createActionGroup({
  source: 'Auth',
  events: {
    'Login': props<{ target: string }>(),
    'Logout': emptyProps(),
    'Signup': props<{ target: string }>(),
    'LoginSuccess': emptyProps(),
    'LogoutSuccess': emptyProps(),
    'SignupSuccess': emptyProps(),
  }
});
